var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group" }, [
    _c(
      "div",
      { staticClass: "group-header" },
      [
        _c(
          "yxt-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.dragging,
                expression: "!dragging",
              },
            ],
            staticClass: "group-header-btn--text",
            attrs: { type: "plain" },
            on: { click: _vm.toQuick },
          },
          [
            _c(
              "tooltip-content",
              {
                attrs: {
                  center: "",
                  content: _vm.$t("pc_biz_group_quick" /*快速分组*/),
                },
              },
              [_vm._v(_vm._s(_vm.$t("pc_biz_group_quick" /*快速分组*/)))]
            ),
          ],
          1
        ),
        _c(
          "yxt-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.dragging,
                expression: "!dragging",
              },
            ],
            staticClass: "group-header-btn--text",
            attrs: { "drag-value": "new", type: "plain" },
            on: { click: _vm.addEmptyGroup },
          },
          [
            _c(
              "tooltip-content",
              {
                attrs: {
                  center: "",
                  content: _vm.$t("pc_biz_group_new" /*添加分组*/),
                },
              },
              [_vm._v(_vm._s(_vm.$t("pc_biz_group_new" /*添加分组*/)))]
            ),
          ],
          1
        ),
        _c(
          "yxt-tooltip",
          {
            staticClass: "item",
            attrs: {
              effect: "dark",
              content: _vm.$t("pc_biz_group_clear" /*重置分组*/),
              placement: "top",
            },
          },
          [
            _c("yxt-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.dragging,
                  expression: "!dragging",
                },
              ],
              staticClass: "group-header-btn--icon",
              attrs: { icon: "yxt-icon-refresh" },
              on: { click: _vm.clearGroup },
            }),
          ],
          1
        ),
        _c(
          "yxt-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dragging,
                expression: "dragging",
              },
            ],
            staticClass: "group-header-add group-header-btn--full",
            attrs: { "drag-value": "new", type: "plain" },
          },
          [
            _c("i", { staticClass: "yxt-icon-plus" }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("pc_biz_group_add" /*新的分组*/)) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "group-content" }, [
      _c(
        "div",
        {
          class: {
            "group-content-not": true,
            "group-content-not--active": !_vm.id,
          },
          attrs: { "drag-value": "none" },
          on: {
            click: function ($event) {
              return _vm.setGroupId("")
            },
          },
        },
        [
          _c("span", { staticClass: "group-content-not__name" }, [
            _vm._v(_vm._s(_vm.$t("pc_biz_group_none" /* 未分组 */))),
          ]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.leftMemberNum) + "/" + _vm._s(this.memberList.length)
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "group-content-list" },
        [
          _c("List", {
            attrs: {
              "group-list": _vm.groupList,
              id: _vm.id,
              dragging: _vm.dragging,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }